import { DateTimeString } from '@app/shared/types';
import { IRfq } from 'v2/modules/rfq/interfaces/rfq.interface';

import { ISupplierPurchaseOrder } from './supplier-purchase-order.interface';

export interface IOrderTransfer {
  id :number;
  createdAt :Date | DateTimeString;
  createdBy ?:ICreatedBy; // optional relation
  updatedAt :Date | DateTimeString;

  arrivalDate :string;
  autoReceiveOrderOnArrival :boolean | 0 | 1;
  channel ?:any;
  destinationWarehouse ?:IWarehouse; // optional relation
  destinationWarehouseId :number;
  itemsCost :number;
  note :string;
  orderDate :string;
  orderItems ?:ISalesOrderItem[]; // optional relation
  orderNumber :string;
  orderStatus :EOrderTransferStatus;
  salesOrder ?:any; // optional relation
  shippingCost :number;
  shippingMethod :string;
  sourceWarehouse ?:IWarehouse; // optional relation
  sourceWarehouseId :number;
  supplierPurchaseOrder ?:ISupplierPurchaseOrder; // optional relation
}

interface ICreatedBy {
  id :number;
  createdAt :number;
  updatedAt :number;

  email :string;
  firstName :string;
  fullName :string;
  isAdmin :boolean;
  language :string;
  lastName :string;
  mobile :string;
  phone :string;
  photoUrl :string;
  status :string;
  timezone :string;
}

interface IWarehouse {
  id :number;
  createdAt :Date | DateTimeString;
  createdBy :number;
  deletedAt :Date | DateTimeString;
  deletedBy :number;
  updatedAt :Date | DateTimeString;
  updatedBy :number;

  address :string;
  city :string;
  country :string;
  locationName :string;
  meta :any;
  parentId :number;
  state :string;
  status :string;
  streetAddress1 :string;
  streetAddress2 :string;
  zip :string;
}

export interface ISalesOrderItem {
  id :number;
  createdAt :Date | DateTimeString;
  updatedAt :Date | DateTimeString;

  baseUomId :number;
  description :string;
  internalSku :string;
  item ?:IRfq; // optional relation
  lineItemCost :number;
  orderedQty :number;
  orderedUomId :number;
  productName :string;
  quantity :number;
  rfqId :number;
  transferOrderId :number;
  unitCost :number;
}

export enum EOrderTransferStatus {
  DRAFT = 'DRAFT',
  POSTED = 'POSTED',
}
